import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import FlowbiteToast from "../../../../node_modules/flowbite-svelte/dist/toast/Toast.svelte";
import { bindPropStore } from "../bindProps";
import { bool, emit, label, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span aria-hidden="true"></span>`);
var root_1 = $.from_html(`<div class="slex-toast-title"><!><span> </span></div>`);
var root_2 = $.from_html(`<div class="slex-toast-description"> </div>`);
var root_3 = $.from_html(`<!> <!>`, 1);
var root_4 = $.from_html(`<div class="slex-toast-group" data-scope="toast"><!></div>`);

export default function Toast($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let visible = $.state(true);

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	$.user_effect(() => {
		const title = titleText();
		const description = descriptionText();
		const type = tone();

		if (!title && !description && !type) return;

		$.set(visible, true);

		const ms = durationMs();

		if (ms <= 0) return;

		const timer = setTimeout(
			() => {
				$.set(visible, false);
			},
			ms
		);

		return () => clearTimeout(timer);
	});

	function tone() {
		const raw = text($.get(p).type ?? $.get(p).tone ?? "info").toLowerCase();

		if (raw === "error" || raw === "destructive") return "danger";
		if (raw === "neutral" || raw === "default") return "info";

		return raw;
	}

	function titleText() {
		return text($.get(p).title ?? $.get(p).label ?? $.get(p).heading);
	}

	function descriptionText() {
		return text($.get(p).description ?? $.get(p).text ?? $.get(p).message ?? $.get(p).content);
	}

	function dismissable() {
		if ($.get(p).dismissable === undefined && $.get(p).dismissible === undefined) return true;

		return bool($.get(p).dismissable ?? $.get(p).dismissible);
	}

	function durationMs() {
		const value = Number($.get(p).duration ?? 0);

		return Number.isFinite(value) && value > 0 ? value : 0;
	}

	function close() {
		if (!$.get(visible)) return;

		$.set(visible, false);
		emit($$props.ctx, "close", { type: "close", target: $$props.ctx.id });
	}

	function handleGroupClick(event) {
		const target = event.target;

		if (!(target instanceof Element)) return;
		if (target.closest(".slex-toast-close")) close();
	}

	function role() {
		return tone() === "danger" ? "alert" : "status";
	}

	function color() {
		const kind = tone();

		if (kind === "success") return "green";
		if (kind === "warning") return "yellow";
		if (kind === "danger") return "red";
		if (kind === "muted" || kind === "neutral") return "gray";

		return "blue";
	}

	function closeLabel() {
		return label($$props.ctx, "toast.close", $.get(p).closeLabel ?? $.get(p).closeAriaLabel, "Close");
	}

	var div = root_4();
	var node = $.child(div);

	{
		var consequent_3 = ($$anchor) => {
			{
				const icon = ($$anchor) => {
					var span = root();

					$.append($$anchor, span);
				};

				let $0 = $.derived(tone);
				let $1 = $.derived(color);
				let $2 = $.derived(role);
				let $3 = $.derived(() => role() === "alert" ? "assertive" : "polite");
				let $4 = $.derived(dismissable);
				let $5 = $.derived(closeLabel);

				FlowbiteToast($$anchor, {
					class: 'slex-toast',
					get 'data-tone'() {
						return $.get($0);
					},

					get color() {
						return $.get($1);
					},

					get role() {
						return $.get($2);
					},

					get 'aria-live'() {
						return $.get($3);
					},

					get dismissable() {
						return $.get($4);
					},

					get closeAriaLabel() {
						return $.get($5);
					},

					classes: {
						icon: "slex-toast-mark",
						content: "slex-toast-content",
						close: "slex-toast-close"
					},
					onclose: close,
					get toastStatus() {
						return $.get(visible);
					},

					set toastStatus($$value) {
						$.set(visible, $$value, true);
					},
					icon,
					children: ($$anchor, $$slotProps) => {
						var fragment_1 = root_3();
						var node_1 = $.first_child(fragment_1);

						{
							var consequent_1 = ($$anchor) => {
								var div_1 = root_1();
								var node_2 = $.child(div_1);

								{
									var consequent = ($$anchor) => {
										InlineIcon($$anchor, {
											get name() {
												return $.get(p).icon;
											},
											className: 'slex-toast-icon'
										});
									};

									$.if(node_2, ($$render) => {
										if ($.get(p).icon) $$render(consequent);
									});
								}

								var span_1 = $.sibling(node_2);
								var text_1 = $.child(span_1, true);

								$.reset(span_1);
								$.reset(div_1);
								$.template_effect(($0) => $.set_text(text_1, $0), [() => titleText()]);
								$.append($$anchor, div_1);
							};

							var d = $.derived(() => titleText());

							$.if(node_1, ($$render) => {
								if ($.get(d)) $$render(consequent_1);
							});
						}

						var node_3 = $.sibling(node_1, 2);

						{
							var consequent_2 = ($$anchor) => {
								var div_2 = root_2();
								var text_2 = $.child(div_2, true);

								$.reset(div_2);
								$.template_effect(($0) => $.set_text(text_2, $0), [() => descriptionText()]);
								$.append($$anchor, div_2);
							};

							var d_1 = $.derived(() => descriptionText());

							$.if(node_3, ($$render) => {
								if ($.get(d_1)) $$render(consequent_2);
							});
						}

						$.append($$anchor, fragment_1);
					},
					$$slots: { icon: true, default: true }
				});
			}
		};

		$.if(node, ($$render) => {
			if ($.get(visible)) $$render(consequent_3);
		});
	}

	$.reset(div);
	$.delegated('click', div, handleGroupClick);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);